import { render, staticRenderFns } from "./myStart.vue?vue&type=template&id=2580e5b7&scoped=true"
import script from "./myStart.vue?vue&type=script&lang=js"
export * from "./myStart.vue?vue&type=script&lang=js"
import style0 from "./myStart.vue?vue&type=style&index=0&id=2580e5b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580e5b7",
  null
  
)

export default component.exports